import type { Entity } from '@backstage/catalog-model';

export const showMonitoring = (entity: Entity) =>
  !entity.metadata.tags?.includes('hide-monitoring');
